import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "../styles/crearTorneo.css";
import Swal from "sweetalert2";

const categoriasOptions = {
  Libres: ["Suma8", "5ta", "6ta", "7ma", "8va"],
  Damas: ["Suma11", "6ta", "7ma", "8va"]
};

export default function CrearTorneo() {
  const { token, rol } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombre: "",
    genero: "Libres", // Género por defecto
    categoria: "",
    fecha_inicio: "",
    fecha_fin: "",
    fecha_limite_inscripcion: "", 
    costo_inscripcion: ""
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  if (rol !== "admin") {
    navigate("/"); // Redirige al inicio si no es administrador
    return null;
  }

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");

  // Validar que la fecha límite de inscripción sea antes de la fecha de inicio
  if (new Date(form.fecha_limite_inscripcion) >= new Date(form.fecha_inicio)) {
    setError("La fecha límite de inscripción debe ser antes de la fecha de inicio.");
    return;
  }

  try {
    await api.post("/torneos", form, {
      headers: { Authorization: `Bearer ${token}` }
    });

    // Mostrar SweetAlert de éxito
    Swal.fire({
      title: "¡Torneo Creado!",
      text: "El torneo se ha creado exitosamente.",
      icon: "success",
      confirmButtonText: "Aceptar"
    }).then(() => {
      navigate("/admin/panel"); // Redirige al panel administrador después de cerrar el SweetAlert
    });
  } catch (err) {
    setError("Error al crear el torneo.");
    console.error(err);
  }
};

  return (
    <div className="form-torneo-container">
      <form onSubmit={handleSubmit} className="form-torneo">
        <h2>Crear Nuevo Torneo</h2>
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}

        <label>Nombre</label>
        <input
          name="nombre"
          value={form.nombre}
          onChange={handleChange}
          placeholder="Nombre del torneo"
          required
        />

        <label>Género</label>
        <select
          name="genero"
          value={form.genero}
          onChange={(e) => {
            setForm({ ...form, genero: e.target.value, categoria: "" });
          }}
        >
          <option value="Libres">Libres</option>
          <option value="Damas">Damas</option>
        </select>

        <label>Categoría</label>
        <select
          name="categoria"
          value={form.categoria}
          onChange={handleChange}
          required
          disabled={!form.genero}
        >
          <option value="">Selecciona categoría</option>
          {form.genero &&
            categoriasOptions[form.genero]?.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
        </select>


        <label>Fecha Límite Inscripción</label>
        <input
          type="date"
          name="fecha_limite_inscripcion"
          value={form.fecha_limite_inscripcion}
          onChange={handleChange}
          required
        />

        <label>Fecha Inicio</label>
        <input
          type="date"
          name="fecha_inicio"
          value={form.fecha_inicio}
          onChange={handleChange}
          required
        />

        <label>Fecha Fin</label>
        <input
          type="date"
          name="fecha_fin"
          value={form.fecha_fin}
          onChange={handleChange}
        />


        <label>Costo Inscripción ($)</label>
        <input
          type="number"
          name="costo_inscripcion"
          value={form.costo_inscripcion}
          onChange={handleChange}
          placeholder="Ejemplo: 500"
          required
        />

        <button type="submit">Crear Torneo</button>
        <button type="button" onClick={() => navigate("/admin/panel")}>
          Cancelar
        </button>
      </form>
    </div>
  );
}